export const toCurrency = (value) => {
  let val = Number(value);
  if (Number.isNaN(val)) {
    val = 0
  }
  return val.toLocaleString(undefined, {
    style: 'currency',
    currency: 'USD'
  });
};
